import React, { useMemo } from "react";
import Chart from "components/charts/Chart";
import { palette } from "lib/chartTheme";

const INCOME_RANGES = [
  { key: "under25k", label: "<$25k" },
  { key: "25to50k", label: "$25-50k" },
  { key: "50to75k", label: "$50-75k" },
  { key: "75to100k", label: "$75-100k" },
  { key: "100to150k", label: "$100-150k" },
  { key: "over150k", label: ">$150k" },
];

const OPTIONS = {
  colors: [palette.sage],
  plotOptions: { bar: { borderRadius: 4, columnWidth: "70%" } },
  xaxis: { categories: INCOME_RANGES.map((range) => range.label) },
  yaxis: { labels: { formatter: (val) => `${val}%` } },
  tooltip: { y: { formatter: (val) => `${val}% of households` } },
};

const HouseholdIncomeChart = ({ data }) => {
  const { series, empty } = useMemo(() => {
    const total = INCOME_RANGES.reduce((sum, { key }) => sum + (data?.[key] || 0), 0);
    const percentages = INCOME_RANGES.map(({ key }) =>
      total > 0 ? Math.round(((data[key] || 0) / total) * 100) : 0
    );
    return { series: [{ name: "Percentage", data: percentages }], empty: total === 0 };
  }, [data]);

  return (
    <Chart
      type="bar"
      series={series}
      options={OPTIONS}
      height={300}
      empty={empty}
      emptyText="No income data yet"
    />
  );
};

export default HouseholdIncomeChart;
